import { z } from 'zod';

/**
 * Canonical date schema — ISO 8601 string.
 * All dates in the system use this single format.
 *
 * Firestore Timestamps are converted to ISO strings at the DAO boundary.
 */
export const DateSchema = z.string().datetime();
